import parseDate from '@/helpers/parseDate'

export default function getDateAndMonth (d) {
  const { date, month } = parseDate(d)

  return `${date} ${month}`
}
